// bao migrate skip
import TabPage from "./../factories/tab-page";
import "./../services/bao-menu";
import "./../bindings/validate";
import "./../bindings/bao-searcher";
import "./../bindings/bao-date-time-picker";
import "./../bindings/bao-date-time-box";
import "./../services/bao-router";
import BaseSearchPaging2 from "./../factories/search-paging2";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import TabController from "./../factories/tab-controller";
import BaoDialog from "./../factories/bao-dialog";
import BaoSearchDialog from "./../factories/bao-search-dialog";

class HolidaySchemaViewModel extends BaseSearchPaging2 {
    public SpecialHolidayTab: TabPage;
    public VacationTab: TabPage;
    public constructor(tabPage: TabPage) {
        super(tabPage);
        this.PermissionForward = "HolidaySchemaMoveForwardSearch";
        this.PermissionBackward = "HolidaySchemaMoveBackwardSearch";
    }
    public CompleteCheck(): JQueryPromise<boolean> | boolean {
        var completed: boolean;
        completed = true;
        if (!completed) {
            var baoDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return completed;
    }
    public InitUrl(): string {
        return "HolidaySchema/Init";
    }
    public initTabs() {
        return super.InitTabController().then(() => {
            this.SpecialHolidayTab = new TabPage();
            this.SpecialHolidayTab.IsClosable(false);
            this.SpecialHolidayTab.AutoSelect = true;
            this.SpecialHolidayTab.Url("HolidaySchemaSpecialHolidayTab");
            this.TabController.AddTab(this.SpecialHolidayTab);
            this.VacationTab = new TabPage();
            this.VacationTab.IsClosable(false);
            this.VacationTab.Url("HolidaySchemaVacationTab");
            this.TabController.AddTab(this.VacationTab);
            this.TabController.SelectTab(this.SpecialHolidayTab);
        });
    }
    public init(): JQueryPromise<void> {
        let def = $.Deferred<void>();
        $.when(super.init(), this.initTabs()).then(() => {
            def.resolve();
        });
        return def.promise();
    }
}
export default HolidaySchemaViewModel;